import React from "react";
import Calendar from "react-calendar";
import { isSameDay } from "date-fns";
import { FormattedMessage as T } from "react-intl";
import { SpeedGraph } from "./SpeedGraph";
import { DashboardMessageList } from "./DashboardMessageList";
import { DashboardServiceIntervalList } from "./DashboardServiceIntervalList";
import { OnlinePie } from "./OnlinePie";
import { FleetRangeLast30D } from "./FleetRangeLast30D";
import { CarsLastRange } from "./CarsLastRange";
import { BatteryGraph } from "./BatteryGraph";
import { OnlineHeatmap } from "./OnlineHeatmap";
import { Portal } from "../Portal";
import Link from "react-router-dom/es/Link";

const redDays = [Date.parse("2018-07-20"), Date.parse("2018-07-25")];

const greyDays = [Date.parse("2018-07-04")];

export function DashboardCommonAuto({
  battery_yesterday,
  distance_last_30,
  messages,
  distance_yesterday,
  usage_heatmap,
  distance_total,
  online_status,
  portal,
  speed_last_30,
  speed_yesterday,
  serviceIntervals,
  setIntervalCompletion,
  history,
}) {
  const config = { displayModeBar: false };
  const plotLayoutCommons = {
    separators: ",.",
    title: "",
    paper_bgcolor: "rgba(255,255,255,0)",
    plot_bgcolor: "rgba(255,255,255,0)",
    showlegend: false,
    width: 320,
    height: 210,
    margin: { t: 0, b: 25, l: 45, r: 15 },
  };

  const widePlotLayoutCommons = {
    ...plotLayoutCommons,
    width: 662,
  };

  const noAxisValues = {
    autorange: true,
    showgrid: false,
    zeroline: false,
    showline: false,
    autotick: true,
    ticks: "",
    showticklabels: false,
  };

  const dateNow = Date.now();

  return (
    <div className="outer-table-frame dashboard">
      <div className="button-frame">
        <div className="button-block">
          <Link to={`/${portal}/reports`} className="button">
            <T id="reports.reports" defaultMessage="Reports" />
          </Link>
        </div>
      </div>
      <div className="table-frame">
        <div className="table-header">
          <i className="fa fa-tachometer" />
          <T id="base.dashboard" defaultMessage="Dashboard" />
        </div>
        <div className="all-graphs-outer-frame">
          <div className="all-graphs-frame">
            <SpeedGraph
              config={{ config }}
              noAxisValues={noAxisValues}
              widePlotLayoutCommons={widePlotLayoutCommons}
              speed_data={speed_last_30}
            />

            <DashboardMessageList messages={messages} portal={Portal.Auto} />

            <DashboardServiceIntervalList
              serviceIntervals={serviceIntervals}
              setIntervalCompletion={setIntervalCompletion}
              portal={Portal.Auto}
            />

            <OnlinePie
              online_status={online_status}
              config={config}
              plotLayoutCommons={plotLayoutCommons}
              portal={portal}
            />

            <OnlineHeatmap
              usage_heatmap={usage_heatmap}
              widePlotLayoutCommons={widePlotLayoutCommons}
              config={config}
            />

            <FleetRangeLast30D
              config={config}
              plotLayoutCommons={plotLayoutCommons}
              distance_total={distance_total}
            />

            <CarsLastRange
              config={config}
              plotLayoutCommons={plotLayoutCommons}
              distance={distance_yesterday}
              noAxisValues={noAxisValues}
              timeSpan="1d"
            />

            <CarsLastRange
              config={config}
              plotLayoutCommons={plotLayoutCommons}
              distance={distance_last_30}
              noAxisValues={noAxisValues}
              timeSpan="30d"
            />

            {/*////////////////////////////////////////////////////////////////*/}
            {/* this is non functional content for visual presentation only    */}
            {false && (
              <div className="graph-frame">
                <div className="graph-headline">
                  <h5 className="headline-for-icon">
                    <i className="fa fa-wrench" />
                    Werkstattintervall
                  </h5>
                </div>
                <div className="tiny-spacer" />
                <Calendar
                  tileClassName={({ date, view }) => {
                    if (isSameDay(date, dateNow)) {
                      return "calendar-today";
                    }
                    if (redDays.find(greenDay => isSameDay(greenDay, date))) {
                      return "calendar-red-day";
                    }
                    if (greyDays.find(greyDay => isSameDay(greyDay, date))) {
                      return "calendar-grey-day";
                    }
                  }}
                />
              </div>
            )}
            {/*//  //  //  //  //  //  //  //  //  //  //  //  //  //  //  //  */}

            <BatteryGraph
              battery_yesterday={battery_yesterday}
              config={config}
              noAxisValues={noAxisValues}
              widePlotLayoutCommons={widePlotLayoutCommons}
              history={history}
              portal={portal}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
